<template>
  <div class="app-container">
    <CrudTable ref="table" entity="Role" :columns="columns" :requires-domain-id="true" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
import crudIndexMixin from '@/mixins/crud-index';
export default {
  components: {
    CrudTable
  },
  mixins: [crudIndexMixin],
  data() {
    return {
      columns: [{ field: 'name', width: 150 }, 'description']
    };
  }
};
</script>

<style scoped></style>
